(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["expected-delivery-date"] && !Shopify.designMode) return;
  try {
    class ExpectedDeliveryDate extends HTMLElement {
    connectedCallback() {
      this.variantData = this.readVariantData();
      this.productRoot = this.closest('[id*="ProductInformation-"], [id*="QuickAdd-"], .shopify-section, dialog');
      this.handleChange = this.handleChange.bind(this);
      this.productRoot?.addEventListener('change', this.handleChange);
      this.observer = new MutationObserver(() => this.scheduleSync());
      if (this.productRoot) {
        this.observer.observe(this.productRoot, {
          subtree: true,
          childList: true,
          attributes: true,
          attributeFilter: ['value', 'checked', 'selected'],
        });
      }
      this.render();
      this.clockTimer = setInterval(() => this.render(), 60000);
    }

    disconnectedCallback() {
      this.productRoot?.removeEventListener('change', this.handleChange);
      this.observer?.disconnect();
      clearTimeout(this.syncTimer);
      clearInterval(this.clockTimer);
    }

    readVariantData() {
      const source = this.querySelector('[data-expected-delivery-variants]');
      if (!source) return {};

      try {
        return JSON.parse(source.textContent || '{}');
      } catch (error) {
        console.warn('[expected-delivery-date] Invalid variant data:', error);
        return {};
      }
    }

    handleChange(event) {
      if (!(event.target instanceof Element)) return;
      if (event.target.closest('variant-picker, form[action*="/cart/add"], [data-product-form]')) {
        this.scheduleSync();
      }
    }

    scheduleSync() {
      clearTimeout(this.syncTimer);
      this.syncTimer = setTimeout(() => this.syncVariant(), 0);
    }

    syncVariant() {
      const source = this.productRoot?.querySelector('variant-picker script[type="application/json"]');
      if (!source) return;
      try {
        const variant = JSON.parse(source.textContent || 'null');
        if (!variant?.id) {
          this.dataset.available = 'false';
          this.render();
          return;
        }
        this.useVariant(String(variant.id));
        this.dataset.available = String(variant.available === true);
        this.render();
      } catch {
        this.dataset.available = 'false';
        this.render();
      }
    }

    useVariant(variantId) {
      const data = this.variantData?.[variantId];
      if (!data) return;

      this.dataset.available = String(data.available);
      this.dataset.variantId = variantId;
      this.dataset.minDays = data.minDays;
      this.dataset.maxDays = data.maxDays;
      this.dataset.cutoffHour = data.cutoffHour;
      this.dataset.countMode = data.countMode;
      this.dataset.timezone = data.timezone;
      this.dataset.updatedAt = data.updatedAt;
      this.dataset.supplierData = data.supplierData;
      this.render();
    }

    getStoreDateTime(date, timeZone) {
      const options = {
        timeZone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        hour12: false,
      };

      try {
        const parts = new Intl.DateTimeFormat('en-CA', options).formatToParts(date);
        const values = Object.fromEntries(
          parts.filter((part) => part.type !== 'literal').map((part) => [part.type, part.value])
        );

        return {
          year: Number(values.year),
          month: Number(values.month),
          day: Number(values.day),
          hour: Number(values.hour) % 24,
        };
      } catch (error) {
        return {
          year: date.getUTCFullYear(),
          month: date.getUTCMonth() + 1,
          day: date.getUTCDate(),
          hour: date.getUTCHours(),
        };
      }
    }

    addLeadDays(date, days, mode) {
      const result = new Date(date.getTime());
      let remaining = Math.min(365, Math.max(0, Math.ceil(Number(days) || 0)));

      if (mode !== 'business') {
        result.setUTCDate(result.getUTCDate() + remaining);
        return result;
      }

      while (remaining > 0) {
        result.setUTCDate(result.getUTCDate() + 1);
        const weekday = result.getUTCDay();
        if (weekday !== 0 && weekday !== 6) remaining -= 1;
      }

      return result;
    }

    formatDate(date) {
      return new Intl.DateTimeFormat(this.dataset.locale || 'sv-SE', {
        timeZone: 'UTC',
        day: 'numeric',
        month: 'long',
        year: 'numeric',
      }).format(date);
    }

    render() {
      const value = this.querySelector('[data-expected-delivery-value]');
      if (!value) return;

      const note = this.querySelector('[data-expected-delivery-note]');
      const minInput = Number(this.dataset.minDays);
      const maxInput = Number(this.dataset.maxDays);
      const quoteUpdatedAt = Date.parse(this.dataset.updatedAt || '');
      const quoteAge = Date.now() - quoteUpdatedAt;
      const fresh = Number.isFinite(quoteUpdatedAt) && quoteAge >= 0 && quoteAge <= 48 * 60 * 60 * 1000;
      const valid = this.dataset.supplierData === 'true' && this.dataset.available === 'true' && fresh
        && Number.isInteger(minInput) && Number.isInteger(maxInput)
        && minInput >= 0 && maxInput >= minInput && maxInput <= 365;
      if (!valid) {
        if (value.textContent !== this.dataset.unavailable) value.textContent = this.dataset.unavailable;
        if (note) note.hidden = false;
        return;
      }
      const minDays = minInput;
      const maxDays = Math.max(minDays, Number(this.dataset.maxDays) || minDays);
      const cutoffHour = Number(this.dataset.cutoffHour);
      const mode = String(this.dataset.countMode || 'business').toLowerCase() === 'business'
        ? 'business'
        : 'calendar';
      const timeZone = this.dataset.timezone || 'Europe/Stockholm';
      const now = new Date();
      const storeNow = this.getStoreDateTime(now, timeZone);
      const baseDate = new Date(Date.UTC(storeNow.year, storeNow.month - 1, storeNow.day));
      const startsAfterCutoff = Number.isFinite(cutoffHour) && storeNow.hour >= cutoffHour;
      let startDate = baseDate;
      const weekend = [0, 6].includes(baseDate.getUTCDay());
      if (mode === 'business' && weekend) {
        while ([0, 6].includes(startDate.getUTCDay())) startDate.setUTCDate(startDate.getUTCDate() + 1);
      } else if (startsAfterCutoff) {
        startDate = this.addLeadDays(baseDate, 1, mode);
      }
      const minDate = this.addLeadDays(startDate, minDays, mode);
      const maxDate = this.addLeadDays(startDate, maxDays, mode);
      const minLabel = this.formatDate(minDate);
      const maxLabel = this.formatDate(maxDate);

      const label = minLabel === maxLabel ? minLabel : minLabel + ' – ' + maxLabel;
      if (value.textContent !== label) value.textContent = label;

      if (note) {
        note.hidden = this.dataset.supplierData === 'true' || this.dataset.showFallbackNote !== 'true';
      }
    }
  }

  if (!customElements.get('expected-delivery-date')) {
    customElements.define('expected-delivery-date', ExpectedDeliveryDate);
  }
  } catch(e) { console.error(e); }
})();

})();
